import app from 'flarum/forum/app';
import FieldSet from 'flarum/common/components/FieldSet';
import ConnectedApplications from './components/ConnectedApplications';

/**
 * Lists the applications a member connected on their Security page, between
 * their browser sessions (20) and logging out everywhere (10). Only on their
 * own: moderators can open another member's page, but the connections listed
 * are always the viewer's.
 */
export default function addToSecurityPage(items) {
  if (!this.user || this.user.id() !== app.session.user?.id()) return;
  items.add('oauthConnectedApplications', m(FieldSet, {
    className: "UserSecurityPage-connectedApplications",
    label: app.translator.trans('flarum-oauth-provider.forum.connected_apps.heading'),
    description: app.translator.trans('flarum-oauth-provider.forum.connected_apps.help_text')
  }, m(ConnectedApplications, null)), 15);
}